import { useQuery } from '@tanstack/react-query';
import { appointmentsService } from '../services/appointmentsService.service';
import { Appointment } from '../adapters/appointmentAdapter';

export const useAppointments = (location?: string) => {
  return useQuery<Appointment[]>({
    queryKey: ['appointments', location],
    queryFn: () => appointmentsService.getAppointments(location)
  });
};
